var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmployeePlaceholder = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "a",
  cx: 19.911,
  cy: 19.911,
  r: 19.911
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#6467EF",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#b)",
  fill: "#F6F6F6"
}, /*#__PURE__*/React.createElement("path", {
  d: "M33.847 39.693s-5.777 1.244-13.924 1.244C11.777 40.937 6 39.693 6 39.693c.263-5.596 3.323-7.716 6.893-8.843 2.35-.74 3.66-2.283 3.824-2.487-1.65-1.46-2.694-3.656-2.91-4.413-.024-.087-.544-.35-.587-.427-1.88-3.326.173-3.703.173-3.703s-.096-1.753.34-3.4c0 0 1.1-4.087 6.19-4.087 5.087 0 6.19 4.087 6.19 4.087.434 1.647.337 3.4.337 3.4s2.057.377.177 3.703c-.044.077-.564.34-.587.427-.217.757-1.26 2.953-2.91 4.413.163.204 1.473 1.747 3.823 2.487 3.57 1.127 6.627 3.247 6.894 8.843"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmployeePlaceholder);
export default ForwardRef;